<template>
   <div id="app"
        :class="[ $store.state.onIE ? 'onIE' : '', $store.state.isPortrait ? 'portrait-mode' : 'landscape-mode', $store.state.view + '-active', noCssMixBlendMode ? 'no-blend-mode' : '']">
      <Header v-if="this.$store.state.isPortrait"></Header>
      <div class="att-site-wrap" ref="siteWrap" :class="[this.$store.state.isPortrait ? 'mobile-site-wrap' : 'att-site-wrap']">
         <Intro></Intro>
         <Articles></Articles>
         <Conclusions></Conclusions>
      </div>
      <SideNavigation v-if="!this.$store.state.isPortrait"></SideNavigation>
   </div>
</template>

<script>
    import _ from 'lodash'
    import 'TweenMax'

    import content from './content'
    import store from './store'
    import {bus, html, mobileMq, audioContext} from './consts'

    import Intro from './components/Intro'
    import SideNavigation from './components/SideNavigation'
    import Conclusions from './components/Conclusions'
    import Articles from './components/Articles'
    import Header from './components/Header'

    export default {
        name: 'app',
        store,
        components: {
            Intro, Articles, SideNavigation, Conclusions, Header
        },
        data() {
            return {
                resizeTimer: null,
                onIE: this.$store.state.onIE,
                cameFromConclusions: false,
                touchStartPos: null,
                touchEndPos: null
            }
        },
        computed: {
            noCssMixBlendMode() {
                return typeof window.getComputedStyle(document.body).mixBlendMode === 'undefined';
            }
        },
        methods: {
            detectIE() {
                let ua = window.navigator.userAgent,
                    msie = ua.indexOf('MSIE '),
                    trident = ua.indexOf('Trident/'),
                    edge = ua.indexOf('Edge/');

                if (msie > 0 || trident > 0) {
                    return true;
                }

                return false;
            },
        },
        created() {
            let isPortrait = window.innerHeight > window.innerWidth;

            this.$store.commit('checkDeviceSize', isPortrait);
            this.$store.commit('getArticlesLength', content.articles.length);

            // set isTouchDevice to true in store if touch is detected
            window.addEventListener('touchstart', this.onFirstTouch, false);

            // fire a custom event when the user has stopped resizing (for at least 250ms)
            window.addEventListener('resize', () => {
                clearTimeout(this.resizeTimer);
                this.resizeTimer = setTimeout(() => {

                    // emit an event to alert other components
                    bus.$emit('resizeComplete');

                    // update the isPortrait property in the store on resize
                    let isPortrait = window.innerHeight > window.innerWidth;

                    this.$store.commit('checkDeviceSize', isPortrait);
                }, 250);
            });

            // browser detection

            this.$store.commit('checkIE', this.detectIE())

            document.addEventListener('click', () => {
                audioContext.resume();
            })
        }
    }
</script>

<style lang="scss">

   @import 'scss/styles.scss';
   @import "scss/_the-goods";

   .att-site-wrap {
      position                : relative;
      -webkit-font-smoothing  : antialiased;
      -moz-osx-font-smoothing : grayscale;
      background-color        : white;
      width                   : 100%;
   }

   .portrait-site-wrap {
      width : 100%;
   }
</style>



// WEBPACK FOOTER //
// src/App.vue